module.exports = __webpack_public_path__ + "static/media/beer.5cb5a80c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beer.png
// module id = 116
// module chunks = 0